import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { ACTION, INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { appearancePropsMap, commandWithMetadata, getDropdownOption } from '@atlaskit/editor-common/card';
import { cardMessages as messages, linkToolbarMessages } from '@atlaskit/editor-common/messages';
import { isSupportedInParent } from '@atlaskit/editor-common/utils';
import { Fragment } from '@atlaskit/editor-prosemirror/model';
import { useSmartCardContext } from '@atlaskit/link-provider';
import { ButtonItem, LinkItem, MenuGroup, Section } from '@atlaskit/menu';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { changeSelectedCardToLink, setSelectedCardAppearance } from '../pm-plugins/doc';
import { DatasourceDropdownOption, datasourceDisplayInformation } from './DatasourceDropdownOption';
import { getUnavailableMessage } from './LinkToolbarAppearance';
export var LinkAppearanceMenu = function LinkAppearanceMenu(_ref) {
  var _cardContext$value, _setSelectedCardAppea, _setSelectedCardAppea2, _changeSelectedCardTo, _setSelectedCardAppea3;
  var url = _ref.url,
    intl = _ref.intl,
    currentAppearance = _ref.currentAppearance,
    editorState = _ref.editorState,
    allowEmbeds = _ref.allowEmbeds,
    _ref$allowBlockCards = _ref.allowBlockCards,
    allowBlockCards = _ref$allowBlockCards === void 0 ? true : _ref$allowBlockCards,
    allowDatasource = _ref.allowDatasource,
    editorAnalyticsApi = _ref.editorAnalyticsApi,
    isDatasourceView = _ref.isDatasourceView,
    dispatchCommand = _ref.dispatchCommand,
    settingsConfig = _ref.settingsConfig;
  var cardContext = useSmartCardContext();
  var preview = allowEmbeds && cardContext && url && ((_cardContext$value = cardContext.value) === null || _cardContext$value === void 0 ? void 0 : _cardContext$value.extractors.getPreview(url, 'web'));
  var defaultCommand = function defaultCommand() {
    return false;
  };
  if (url) {
    var _cardContext$value2, _urlState$error;
    var urlState = (_cardContext$value2 = cardContext.value) === null || _cardContext$value2 === void 0 || (_cardContext$value2 = _cardContext$value2.store) === null || _cardContext$value2 === void 0 ? void 0 : _cardContext$value2.getState()[url];
    if ((urlState === null || urlState === void 0 || (_urlState$error = urlState.error) === null || _urlState$error === void 0 ? void 0 : _urlState$error.kind) === 'fatal') {
      return null;
    }
  }
  var isBlockCardLinkSupportedInParent = allowBlockCards ? isSupportedInParent(editorState, Fragment.from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
  var isEmbedCardLinkSupportedInParent = allowEmbeds ? isSupportedInParent(editorState, Fragment.from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
  var embedOption = allowEmbeds && preview && {
    appearance: 'embed',
    title: intl.formatMessage(messages.embed),
    onClick: (_setSelectedCardAppea = setSelectedCardAppearance('embed', editorAnalyticsApi)) !== null && _setSelectedCardAppea !== void 0 ? _setSelectedCardAppea : defaultCommand,
    selected: currentAppearance === 'embed',
    hidden: false,
    testId: 'embed-appearance',
    disabled: !isEmbedCardLinkSupportedInParent,
    tooltip: isEmbedCardLinkSupportedInParent ? undefined : getUnavailableMessage(editorState, intl),
    description: editorExperiment('platform_editor_preview_panel_responsiveness', true, {
      exposure: true
    }) ? intl.formatMessage(messages.embedToBlockCardWarning) : undefined
  };
  var blockCardOption = allowBlockCards && {
    appearance: 'block',
    title: intl.formatMessage(messages.block),
    onClick: (_setSelectedCardAppea2 = setSelectedCardAppearance('block', editorAnalyticsApi)) !== null && _setSelectedCardAppea2 !== void 0 ? _setSelectedCardAppea2 : defaultCommand,
    selected: currentAppearance === 'block' && !isDatasourceView,
    testId: 'block-appearance',
    disabled: !isBlockCardLinkSupportedInParent,
    tooltip: isBlockCardLinkSupportedInParent ? undefined : getUnavailableMessage(editorState, intl)
  };
  var options = [{
    title: intl.formatMessage(messages.url),
    onClick: commandWithMetadata((_changeSelectedCardTo = changeSelectedCardToLink(url, url, true, undefined, undefined, editorAnalyticsApi)) !== null && _changeSelectedCardTo !== void 0 ? _changeSelectedCardTo : defaultCommand, {
      action: ACTION.CHANGED_TYPE
    }),
    selected: !currentAppearance && !isDatasourceView,
    testId: 'url-appearance'
  }, {
    appearance: 'inline',
    title: intl.formatMessage(messages.inline),
    onClick: (_setSelectedCardAppea3 = setSelectedCardAppearance('inline', editorAnalyticsApi)) !== null && _setSelectedCardAppea3 !== void 0 ? _setSelectedCardAppea3 : defaultCommand,
    selected: currentAppearance === 'inline',
    testId: 'inline-appearance'
  }];
  if (blockCardOption) {
    options.push(blockCardOption);
  }
  if (embedOption) {
    options.push(embedOption);
  }
  var finalOptions = options.map(function (option) {
    return getDropdownOption(intl, dispatchCommand, _objectSpread(_objectSpread({}, option), {}, {
      onClick: commandWithMetadata(option.onClick, {
        inputMethod: INPUT_METHOD.FLOATING_TB
      })
    }));
  });
  var Icon;
  if ('icon' in settingsConfig && settingsConfig.icon !== undefined) {
    Icon = settingsConfig.icon;
  }

  // TODO: ED-26961 - packages/editor/editor-plugin-card/src/ui/LinkToolbarAppearance.tsx supports change boarding via pulse
  // this implementation doesn't
  return /*#__PURE__*/React.createElement(MenuGroup, null, /*#__PURE__*/React.createElement(Section, null, finalOptions.map(function (option) {
    return /*#__PURE__*/React.createElement(ButtonItem, {
      key: option.title,
      iconBefore: option.icon,
      onClick: function onClick() {
        return option.onClick();
      },
      isSelected: option.selected,
      description: option.description,
      shouldDescriptionWrap: true
    }, option.title);
  }), /*#__PURE__*/React.createElement(DatasourceDropdownOption, {
    allowDatasource: allowDatasource,
    intl: intl,
    url: url !== null && url !== void 0 ? url : '',
    selected: Boolean(isDatasourceView),
    inputMethod: INPUT_METHOD.FLOATING_TB,
    dispatchCommand: dispatchCommand
  })), /*#__PURE__*/React.createElement(Section, {
    hasSeparator: true
  }, /*#__PURE__*/React.createElement(LinkItem, {
    iconBefore: Icon && /*#__PURE__*/React.createElement(Icon, {
      label: "Settings"
    }),
    href: 'href' in settingsConfig ? settingsConfig.href : undefined,
    target: 'target' in settingsConfig ? settingsConfig.target : undefined
  }, intl.formatMessage(linkToolbarMessages.preferencesLink))));
};
export var getLinkAppearanceDropdown = function getLinkAppearanceDropdown(_ref2) {
  var url = _ref2.url,
    intl = _ref2.intl,
    currentAppearance = _ref2.currentAppearance,
    editorState = _ref2.editorState,
    allowEmbeds = _ref2.allowEmbeds,
    _ref2$allowBlockCards = _ref2.allowBlockCards,
    allowBlockCards = _ref2$allowBlockCards === void 0 ? true : _ref2$allowBlockCards,
    allowDatasource = _ref2.allowDatasource,
    editorAnalyticsApi = _ref2.editorAnalyticsApi,
    _ref2$showUpgradeDisc = _ref2.showUpgradeDiscoverability,
    showUpgradeDiscoverability = _ref2$showUpgradeDisc === void 0 ? true : _ref2$showUpgradeDisc,
    isDatasourceView = _ref2.isDatasourceView,
    settingsConfig = _ref2.settingsConfig,
    areAnyNewToolbarFlagsEnabled = _ref2.areAnyNewToolbarFlagsEnabled;
  var alignmentItemOptions = {
    render: function render(props) {
      return /*#__PURE__*/React.createElement(LinkAppearanceMenu, {
        url: url,
        intl: intl,
        currentAppearance: currentAppearance,
        editorState: editorState,
        allowEmbeds: allowEmbeds,
        allowBlockCards: allowBlockCards,
        editorAnalyticsApi: editorAnalyticsApi,
        showUpgradeDiscoverability: showUpgradeDiscoverability,
        isDatasourceView: isDatasourceView,
        allowDatasource: allowDatasource,
        dispatchCommand: props.dispatchCommand,
        settingsConfig: settingsConfig,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
      });
    },
    width: 200,
    height: 400
  };
  var currentAppearanceDisplayInformation = isDatasourceView ? datasourceDisplayInformation : appearancePropsMap[currentAppearance !== null && currentAppearance !== void 0 ? currentAppearance : 'url'];
  var alignmentToolbarItem = {
    id: 'card-appearance',
    testId: 'card-appearance-dropdown',
    type: 'dropdown',
    options: alignmentItemOptions,
    title: intl.formatMessage(currentAppearanceDisplayInformation.title),
    iconBefore: currentAppearanceDisplayInformation.icon
  };
  return alignmentToolbarItem;
};